import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_113: FaireProductEntity = {
  token: "catalog_prod_prod-113",
  type: "product",
  name: "Lumbar Pillow - Embroidered Santa's Sleigh",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=400&fit=crop",
  priceDollars: 59.45,
  msrpDollars: 148.63,
  sku: "VI0113",
  caseSize: 12,
  material: "Glass",
  collectionToken: "col_vintage-holiday",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 50,
  description: "Beautiful Vintage Holiday piece perfect for any home.",
  categoryTokens: ["catalog_cat_storage-organization"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
